import {
  LogLevel,
  PublicClientApplication,
  ProtocolMode,
  type RedirectRequest
} from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    authority: import.meta.env.VITE_APP_IDS_AUTHORITY,
    knownAuthorities: [import.meta.env.VITE_APP_KNOWN_AUTHORITIES],
    protocolMode: ProtocolMode.OIDC,
    clientId: import.meta.env.VITE_APP_IDS_CLIENT_ID,
    redirectUri: import.meta.env.VITE_APP_LOGIN_REDIRECT_URI, // Must be registered as a SPA redirectURI on the ids app registration
    postLogoutRedirectUri: import.meta.env.VITE_APP_LOGOUT_REDIRECT_URI // Must be registered as a SPA redirectURI on the ids app registration
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean
      ) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel:
        import.meta.env.MODE === 'prd' ? LogLevel.Warning : LogLevel.Info
    }
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize();

// Add here scopes for id token to be used as registered on ids.
export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'offline_access', 'IdentityServerApi'],
  extraQueryParameters: {},
  loginHint: ''
  // Add correlation id
};
